import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { selectedTemplateBoardSelector } from '../boardTemplatePickerSelectors';

import { isTemplateExampleBoard } from '../../../../common/templates/templateUtil';

import BoardOperationSpinner from '../../../components/loaders/BoardOperationSpinner';

const mapStateToProps = createStructuredSelector({
    selectedTemplateBoard: selectedTemplateBoardSelector,
});

const BoardTemplatePickerCopyLoader = ({ keepTemplateContentChecked, selectedTemplateBoard }) => {
    const isClearingTemplateContent = !keepTemplateContentChecked && isTemplateExampleBoard(selectedTemplateBoard);

    return (
        <BoardOperationSpinner className="BoardTemplatePickerCopyLoader">
            {isClearingTemplateContent ? 'Clearing template...' : 'Copying template...'}
        </BoardOperationSpinner>
    );
};

BoardTemplatePickerCopyLoader.propTypes = {
    keepTemplateContentChecked: PropTypes.bool,
    selectedTemplateBoard: PropTypes.object,
};

export default connect(mapStateToProps)(BoardTemplatePickerCopyLoader);
